.container {
  text-align: center;
  border: 1px solid var(--menu-border);
  background-color: var(--main-background);
  padding: 15px 60px;
}
